import React from "react"

type Props = {
  className?: string
}

const ChatIcon = ({ className }: Props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M7.07783 21.808C9.78583 21.808 11.9818 19.612 11.9818 16.904C11.9818 14.196 9.78683 12 7.07783 12C4.36883 12 2.17383 14.196 2.17383 16.904"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.083 21.813C6.345 21.813 5.646 21.65 5.018 21.359L2 22L2.631 18.976C2.338 18.346 2.174 17.644 2.174 16.904"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.557 12.028C6.199 11.207 6 10.312 6 9.373C6 5.356 9.598 2.133 14 2.133C18.402 2.133 22 5.356 22 9.373C22 11.747 20.738 13.837 18.801 15.155C18.802 15.911 18.8 16.93 18.8 18L15.661 16.454C15.124 16.557 14.569 16.613 14 16.613C13.293 16.613 12.607 16.529 11.953 16.372"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default ChatIcon
